module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.user), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.cfgType == 'T') ? _c('label', [_c('span', {
      staticClass: "label"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.cfgNeedFl == '1'),
        expression: "item.cfgNeedFl=='1'"
      }],
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]), _vm._v(_vm._s(item.cfgName))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cfgValue),
        expression: "item.cfgValue"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": item.cfgName
      },
      domProps: {
        "value": (item.cfgValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "cfgValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.user_copy[index] === 1 && _vm.dirty),
        expression: "user_copy[index]===1&&dirty"
      }],
      staticClass: "err-msg"
    }, [_vm._v(_vm._s(item.cfgHint))])]) : _vm._e(), _vm._v(" "), (item.cfgType == 'DDL') ? _c('label', [_c('span', {
      staticClass: "label"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.cfgNeedFl == '1'),
        expression: "item.cfgNeedFl=='1'"
      }],
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]), _vm._v(_vm._s(item.cfgName))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cfgValue),
        expression: "item.cfgValue"
      }],
      staticClass: "select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "cfgValue", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.cfgContent.split('|')), function(opt) {
      return _c('option', {
        domProps: {
          "value": opt
        }
      }, [_vm._v(_vm._s(opt))])
    })), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.user_copy[index] === 1 && _vm.dirty),
        expression: "user_copy[index]===1&&dirty"
      }],
      staticClass: "err-msg"
    }, [_vm._v(_vm._s(item.cfgHint))])]) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "next-btn-box"
  }, [_c('button', {
    staticClass: "next-btn",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.next")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4b456e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/addInfo.vue
// module id = 784
// module chunks = 10